function helloFromTypescript() {
  console.log('hello');
}

helloFromTypescript();
